<template>
  <div class="signin-wrapper">
    <div class="form-signin">
      <div class="mb-5 text-center">
        <img src="../assets/img/lifeplus-logo.png" height="25" />
      </div>

      <div class="form-group">
        <input type="text" class="form-control form-control-lg" placeholder="Login" v-model="loginForm.login">
        <input type="password" class="form-control form-control-lg" placeholder="Password" v-model="loginForm.password">
      </div>

      <div class="form-group">
        <button type="submit" class="btn btn-primary btn-block btn-lg" @click="logIn">Sign In</button>
      </div>

      <div class="form-group">
        <p class="text-danger text-center font-weight-bold">{{error}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loginForm: {
          login: '',
          password: '',
        },
        error: '',
      };
    },
    methods: {
      async logIn() {
        if (!this.loginForm.login) {
          this.error = 'Поле Login должно быть заполнено';

          return;
        }

        if (!this.loginForm.password) {
          this.error = 'Поле Password должно быть заполнено';

          return;
        }

        try {
          await this.$store.dispatch('LOG_IN', this.loginForm);
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error) {
            this.error = e.response.data.error;
          } else {
            this.error = 'Сервис временно недоступен';
          }
        }
      }
    }
  };
</script>
